import HeroSection from './HeroSection';
import FeatureGridSection from './FeatureGridSection';
import TrustStripSection from './TrustStripSection';
import StatsSection from './StatsSection';
import CtaSection from './CtaSection';
import RichTextSection from './RichTextSection';
import FaqSection from './FaqSection';

const SECTION_MAP = {
  hero: HeroSection,
  feature_grid: FeatureGridSection,
  trust_strip: TrustStripSection,
  stats: StatsSection,
  cta: CtaSection,
  rich_text: RichTextSection,
  faq: FaqSection,
};

export default function SectionRenderer({ sections = [], skipHero = false }) {
  if (!sections || sections.length === 0) return null;
  return (
    <>
      {sections.map((section, idx) => {
        if (skipHero && idx === 0 && section.section_type === 'hero') return null;
        const Component = SECTION_MAP[section.section_type];
        if (!Component) {
          return section.body ? (
            <RichTextSection key={section.id || idx} section={section} />
          ) : null;
        }
        return <Component key={section.id || idx} section={section} />;
      })}
    </>
  );
}
